import { TOGGLE_ALERTS_MENU } from './constants';

const toggleAlertsMenu = isMenuOpen => ({
  type: TOGGLE_ALERTS_MENU,
  isMenuOpen
});

export { toggleAlertsMenu };
